import { useEffect } from 'react';
import { useCurrentBaseUser } from './useCurrentBaseUser';
import { useUpdateUserLocation } from './useUpdateUserLocation';

export const useGeolocateUser = () => {
  const { data: baseUser } = useCurrentBaseUser();
  const { mutate: updateLocation } = useUpdateUserLocation();

  useEffect(() => {
    if (!baseUser) return;

    // Skip if location already stored
    if (baseUser.lat && baseUser.lng) return;

    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        updateLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      () => {
        // User denied or unavailable — silently ignore
      }
    );
  }, [baseUser]);
};
